<template>
  <v-container fluid>
    <div>
      <v-row>
        <v-col cols="12" class="text-center">
          <span v-if="modelCompany.name" class="text-h3">{{
            modelCompany.name
          }}</span>
          <span v-else class="text-h3">"Company Name"</span>
        </v-col>
      </v-row>
      <v-divider class="pb-10 mt-2"></v-divider>
      <v-form @submit.prevent="submit" ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.name"
                  label="Company Name:"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.companyEmail"
                  label="Company Email:"
                  type="string"
                  :rules="emailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Months"
                  label="Monthly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Weeks"
                  label="Weekly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.pastelCode"
                  label="Company Code:"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.WksMths"
                  label="Wks/Mths Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Fortnights"
                  label="Fortnightly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-row class="ma-3">
            <v-combobox
              v-model="addLoanTypes"
              label="Loan Types:"
              item-text="code"
              item-value="id"
              type="number"
              @change="validateLoanTypes()"
              multiple
              persistent-hint
              chips
              deletable-chips
              clearable
              :error-messages="errorMessage"
            ></v-combobox
          ></v-row>
        </v-row>
      </v-form>
      <v-row class="ma-1">
        <v-spacer></v-spacer>
        <v-btn
          width="4vh"
          color="primary"
          :dark="valid && !loading"
          @click="submit()"
          :disabled="!valid || loading"
          :loading="loading"
        >
          Create
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { CompanyLoanType, Company } from "@/models";
import { DataStore } from "@aws-amplify/datastore";
import _ from "lodash";

export default {
  name: "AddSingleCompany",

  props: {
    loanTypes: null,
  },

  data: () => ({
    loading: false,
    addLoanTypes: [],
    nonExistantLoanTypes: [],
    valid: false,
    errorMessage: "",
    modelCompany: {
      loanApplicationEmails: {
        Months: "",
        Weeks: "",
        WksMths: "",
        Fortnights: "",
      },
    },

    requiredRule: [(v) => !!v || "Required"],
    emailRule: [(v) => !v || /.+@.+\..+/.test(v) || "E-mail must be valid"],
    multipleEmailRule: [
      (v) =>
        !v ||
        /^([a-z][a-z0-9_.]+@([a-z0-9-]+\.)+[a-z]{2,6}(,)*)+$/.test(v) ||
        "E-mail must be valid",
    ],
  }),

  async created() {},
  components: {},

  methods: {
    validateLoanTypes() {
      try {
        this.nonExistantLoanTypes = [];
        this.errorMessage = "";
        if (this.addLoanTypes) {
          for (let a in this.addLoanTypes) {
            const modelFilteredLoanType = _.find(this.loanTypes, {
              code: Number(this.addLoanTypes[a]),
            });

            if (!modelFilteredLoanType) {
              this.nonExistantLoanTypes = _.concat(
                this.nonExistantLoanTypes,
                this.addLoanTypes[a]
              );
            }
          }
          if (this.nonExistantLoanTypes.length > 0) {
            this.errorMessage = `Incorrect Loan Type(s): ${this.nonExistantLoanTypes}`;
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async submit() {
      try {
        this.loading = true;
        let arrLoanTypes = [];
        let createdCompany = {};

        if (this.addLoanTypes) {
          for (let a in this.addLoanTypes) {
            const modelFilteredLoanType = _.find(this.loanTypes, {
              code: Number(this.addLoanTypes[a]),
            });

            if (modelFilteredLoanType) {
              arrLoanTypes = _.concat(arrLoanTypes, modelFilteredLoanType);
            }
          }
        }
        if (this.nonExistantLoanTypes.length === 0) {
          createdCompany = await DataStore.save(
            new Company({
              name: this.modelCompany.name,
              pastelCode: this.modelCompany.pastelCode.trim().toUpperCase(),
              status: "ACTIVE",
              companyEmail: this.modelCompany.companyEmail,
              loanApplicationEmails: this.modelCompany.loanApplicationEmails,
            })
          );
        }
        if (createdCompany) {
          for (let lt in arrLoanTypes) {
            await DataStore.save(
              new CompanyLoanType({
                company: createdCompany,
                loanType: arrLoanTypes[lt],
              })
            );
          }
        }
        this.loading = false;
        this.$emit("createdCompany");
      } catch (error) {
        console.log("error", error);
      }
    },
  },
  computed: {},
};
</script>